import { render } from "./RedirectPage.vue?vue&type=template&id=0c967a80"
import script from "./RedirectPage.vue?vue&type=script&lang=js"
export * from "./RedirectPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__